export default __webpack_public_path__ + "media/images/front/municipality_collaboration/train-c681e4fd68b83064b2375c4b3d571f69.png";